export const moduleConfig = {
    entityKey: 'billingProviders',
    // Every navigate and link in the module builds on this (§1).
    basePath: '/billing-providers',
    titles: {
        singular: 'Billing Provider',
        plural: 'Billing Providers'
    }
}
